import { render, staticRenderFns } from "./HQConsolidatedProfitLoss.vue?vue&type=template&id=71f5812c&scoped=true&"
import script from "./HQConsolidatedProfitLoss.vue?vue&type=script&lang=js&"
export * from "./HQConsolidatedProfitLoss.vue?vue&type=script&lang=js&"
import style0 from "./HQConsolidatedProfitLoss.vue?vue&type=style&index=0&id=71f5812c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5812c",
  null
  
)

export default component.exports